"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AreaController {
    constructor() {
        this.areas = [];
        this.area = {
            gis_area_id: -1,
            meta: {
                category: '',
                name: '',
                crop: {
                    id: 0,
                    name: '',
                    logo_name: '',
                },
                extension: 0,
                extension_units: '',
                polygon: '',
            },
        };
        this.fetchAllAreasError = 'without errors';
        this.areasCompleted = [];
        this.areasOngoing = [];
        this.itemsPerPageClient = 5;
        this.itemsPerPageServer = 50;
        this.currentPage = 1;
        this.loader = false;
        this.areasFilter = [];
        this.orderCriteria = '';
        this.orderDirection = 0;
        this.areasOrder = [];
        this.textSearch = '';
        this.stages = [
            {
                code: 'gis_file_upload',
                title: 'Gis File Upload',
            },
            {
                code: 'calculating_zones',
                title: 'Calculating Zones (BMK)',
            },
            {
                code: 'sample_collecting',
                title: 'Sample Collecting (User)',
            },
            {
                code: 'sample_shipping',
                title: 'Sample Shipping (User)',
            },
            {
                code: 'lab_received',
                title: 'Lab received (Lab BMK)',
            },
            {
                code: 'lab_dna_extraction',
                title: 'DNA extracted (Lab BMK)',
            },
            {
                code: 'lab_pcr',
                title: 'PCR-ed (Lab BMK)',
            },
            {
                code: 'lab_pool',
                title: 'Pool-ed (Lab BMK)',
            },
            {
                code: 'lab_sequenced',
                title: 'Sequenced (Lab BMK)',
            },
            {
                code: 'lab_quality_control',
                title: 'Quality Control (Lab BMK)',
            },
            {
                code: 'metadata',
                title: 'Metadata Upload (User)',
            },
            {
                code: 'result',
                title: 'Result (BMK)',
            },
        ];
    }
    async fetchAllAreas(url) {
        /*  try {
            const request = await fetch(url);
            const response = await request.json();
            this.areas = response;
        } catch (error) {
            this.areas = this.fakeData;
            this.fetchAllAreasError = error.data;
            console.error(error);
        } */
    }
    async fetchArea(url) {
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.area = response;
        }
        catch (error) {
            this.fetchAllAreasError = error.data;
            console.error(error);
        }
    }
    get allAreas() {
        return this.areas;
    }
    completed() {
        /* const areasCompleted: Array<gisArea_i> = [];
        this.allAreas.forEach((element: gisArea_i) => {
            if (element.life_cycle_area.name === 'Result') areasCompleted.push(element);
        });
        this.areasCompleted = areasCompleted;
        return areasCompleted; */
    }
    ongoing() {
        /*   const areasOngoing: Array<gisArea_i> = [];
        this.allAreas.forEach((element: gisArea_i) => {
            if (element.life_cycle_area.name !== 'Result') areasOngoing.push(element);
        });
        this.areasOngoing = areasOngoing;
        return areasOngoing; */
    }
    filter(textSearch) {
        /*  this.updateOrder();
        this.textSearch = textSearch;

        if (this.textSearch.length > 0) {
            return (this.areasFilter = this.allAreas.filter((area: gisArea_i) => {
                if (textSearch === '#user') {
                    return area.life_cycle_area.phase === 'user';
                } else if (textSearch === '#bmk') {
                    return area.life_cycle_area.phase === 'bmk';
                } else if (textSearch === '#pending') {
                    return area.life_cycle_area.name !== 'Result';
                } else {
                    return (
                        area.meta.name
                            .toLowerCase()
                            .includes(textSearch.trim().toLowerCase()) ||
                        area.life_cycle_area.name
                            .toLowerCase()
                            .includes(textSearch.trim().toLowerCase()) ||
                        area.project_type
                            .toLowerCase()
                            .includes(textSearch.trim().toLowerCase()) ||
                        area.proposal_id
                            .toLowerCase()
                            .includes(textSearch.trim().toLowerCase())
                    );
                }
            }));
        } else {
            this.areasFilter = this.allAreas;
            return this.allAreas;
        } */
    }
    explainHint(area) {
        /*  if (area.life_cycle_area.status === 'on_track') {
            return 'So far everything is on track for this project. We will notify you if you need to do something else';
        }
        if (area.life_cycle_area.status === 'action_required') {
            return (
                'You need to perform the following action to keep the project going: ' +
                area.status.name
            );
        }
        if (area.life_cycle_area.status === 'completed') {
            return 'All done. You can check your results in the Results Module';
        } */
    }
    stageAreaSelected(area) {
        /*   return area.life_cycle_area.name; */
    }
    proposalStageNumber(area) {
        /*  const stageIx = this.stages.findIndex(
            (stage) => stage.code === area.life_cycle_area.slug
        );
        return stageIx; */
    }
    // order
    chooseSortable(newCriteria) {
        const directions = [1, -1, 0];
        if (newCriteria === this.orderCriteria) {
            let nextDirection = directions.findIndex((a) => a === this.orderDirection);
            nextDirection === directions.length - 1
                ? (nextDirection = 0)
                : nextDirection++;
            this.orderDirection = directions[nextDirection];
        }
        else {
            this.orderCriteria = newCriteria;
            this.orderDirection = 1;
        }
        this.updateOrder();
    }
    getMyKey(criteria) {
        if (criteria === 'type')
            return 'type';
        if (criteria === 'proposals')
            return 'code_name';
        if (criteria === 'areas')
            return 'name';
        if (criteria === 'stage')
            return 'name';
        return 'id';
    }
    updateOrder() {
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        const keyToSort = this.getMyKey(this.orderCriteria);
        this.areasOrder = this.areasPaginated();
        if (this.orderDirection === 0) {
            return;
        }
        this.areasOrder = this.areasOrder.sort((a, b) => {
            if (this.orderDirection === -1) {
                if (this.orderCriteria === 'type') {
                    return a.project_type > b.project_type ? -1 : 1;
                }
                if (this.orderCriteria === 'proposal') {
                    return a.proposal_id > b.proposal_id ? -1 : 1;
                }
                if (this.orderCriteria === 'areas') {
                    return a.meta[keyToSort] > b.meta[keyToSort] ? -1 : 1;
                }
                if (this.orderCriteria === 'stage') {
                    return a.life_cycle_area[keyToSort] > b.life_cycle_area[keyToSort]
                        ? -1
                        : 1;
                }
                return fixNullsValue(a[keyToSort]) > fixNullsValue(b[keyToSort]) ? -1 : 1;
            }
            else {
                if (this.orderCriteria === 'type' || this.orderCriteria === 'proposals') {
                    return a.project[keyToSort] < b.project[keyToSort] ? -1 : 1;
                }
                if (this.orderCriteria === 'areas') {
                    return a.meta[keyToSort] < b.meta[keyToSort] ? -1 : 1;
                }
                else if (this.orderCriteria === 'stage') {
                    return a.life_cycle_area[keyToSort] < b.life_cycle_area[keyToSort]
                        ? -1
                        : 1;
                }
                else {
                    return fixNullsValue(a[keyToSort]) < fixNullsValue(b[keyToSort])
                        ? -1
                        : 1;
                }
            }
        });
    }
    // pagination
    areasPaginated() {
        if (this.numPages > 1 && this.areasFilter.length > this.itemsPerPageClient) {
            const areas = [];
            let areasPagination = [];
            this.areasFilter.forEach((element) => {
                areas.push(element);
            });
            if (this.currentPage === 1) {
                areasPagination = areas.slice(0, this.itemsPerPageClient);
            }
            else {
                areasPagination = areas.slice(this.currentPage * this.itemsPerPageClient - this.itemsPerPageClient, this.currentPage * this.itemsPerPageClient);
            }
            return areasPagination;
        }
        else {
            return this.areasFilter;
        }
    }
    setCurrentPage(page) {
        this.loader = true;
        this.currentPage = page;
        this.areasPaginated();
        setTimeout(() => {
            this.loader = false;
        }, 2000);
    }
    get numPages() {
        if (this.areasFilter.length >= this.itemsPerPageClient) {
            return Math.ceil(this.areasFilter.length / this.itemsPerPageClient);
        }
        else {
            return 1;
        }
    }
    get pagesClient() {
        return this.itemsPerPageClient;
    }
    get pagesServer() {
        return this.itemsPerPageServer;
    }
    changePagesServer(newValue) {
        this.itemsPerPageServer = newValue;
    }
}
exports.default = AreaController;
